export enum NODE_ENVS {
	Test = 'test',
	Development = 'development',
	Production = 'production',
}
